<template>
  <div class="container-fluid">
    <div class="row">
      <LayoutLeftAuth />

      <div class="col-md-5 password-success">
        <div
          class="container h-full d-flex align-items-center justify-content-center"
        >
          <div class="row d-flex flex-column text-center align-items-center">
            <img
              src="../assets/img/blue-logo.png"
              class="logo-mobile-auth d-block d-sm-none"
            />
            <div class="changed-title">
              404
            </div>
            <div class="changed-undertitle">
              PAGE NOT FOUND. Proceed to
              <router-link class="thick-font changed-router-links" to="/"
                >login.</router-link
              >
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import LayoutLeftAuth from "../components/auth/LayoutLeftAuth";

export default {
  components: {
    LayoutLeftAuth
  }
};
</script>
<style scoped>
.password-success {
  font-weight: 500;
  text-align: center;
}
.changed-title {
  font-size: 40px;
  line-height: 48px;
  letter-spacing: -0.72px;
  color: #131c36;
}
.changed-router-links {
  font-size: 18px;
}
.changed-undertitle {
  font-size: 18px;
  line-height: 24px;
  color: #3e475e;
  margin-top: 7px;
  margin-bottom: 43px;
}
</style>
